const comments = [
  {
    name: '电影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20abstract%20portrait%20style%20avatar%20with%20warm%20amber%20and%20coral%20tones%2C%20soft%20geometric%20shapes%2C%20clean%20modern%20design%2C%20friendly%20feel&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    date: '2026-07-30',
    text: '小草影院真的太好用了！片库超全，更新也快，昨天刚上映的片子今天就能看到，画质也很清晰，强烈推荐给所有爱看电影的朋友。',
    rating: 5,
  },
  {
    name: '喜剧爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20abstract%20portrait%20style%20avatar%20with%20warm%20golden%20and%20peach%20tones%2C%20soft%20curves%2C%20clean%20modern%20design%2C%20cheerful%20feel&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    date: '2026-07-29',
    text: '喜剧电影分类做得特别好，周星驰全集、沈腾系列都整理得很清楚。下班回家看一部喜剧，一天的疲惫都没了，太解压了！',
    rating: 5,
  },
  {
    name: '科幻迷老张',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20abstract%20portrait%20style%20avatar%20with%20deep%20crimson%20and%20bronze%20tones%2C%20angular%20geometric%20shapes%2C%20clean%20modern%20design%2C%20serious%20feel&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    date: '2026-07-28',
    text: '作为一个科幻迷，小草影院的科幻分类让我很惊喜。从经典到最新科幻大片都有，而且分类标签很清晰，找片效率超高。',
    rating: 4,
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20abstract%20portrait%20style%20avatar%20with%20warm%20rose%20and%20copper%20tones%2C%20flowing%20geometric%20shapes%2C%20clean%20modern%20design%2C%20youthful%20feel&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    date: '2026-07-27',
    text: '每天都会来小草影院逛一圈，看看有没有新上线的影片。片库每天都在更新，永远不会片荒，简直是电影爱好者的天堂。',
    rating: 5,
  },
  {
    name: '影评人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20abstract%20portrait%20style%20avatar%20with%20warm%20terracotta%20and%20sand%20tones%2C%20structured%20geometric%20shapes%2C%20clean%20modern%20design%2C%20professional%20feel&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    date: '2026-07-26',
    text: '作为业余影评人，小草影院的影片信息整理得很到位。分类清晰、更新及时，是我日常找片参考的重要平台，值得推荐。',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            用户好评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            听听小草影院用户们的真实评价
          </p>
        </div>

        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex-shrink-0 rounded-full overflow-hidden">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5 flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.date}</span>
                    </div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`ri-star-fill text-xs ${
                            j < comment.rating ? 'text-accent-500' : 'text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}